import { documentAvailable } from '~/utils/client-detection';

const userlane = documentAvailable() ? document.createElement('script') : undefined;
if (userlane) {
	userlane.type = 'text/javascript';
	userlane.innerHTML = `
	(function(i,s,o,g,r,a,m)
	{i['UserlaneCommandObject']=r;
	i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)};
	a=s.createElement(o),m=s.getElementsByTagName(o)[0];
	a.async=1;
	a.src=g;
	m.parentNode.insertBefore(a,m)})(window,document,'script','https://cdn.userlane.com/userlane.js','Userlane');
	
	const clientUrl = new URL(window.location.href);
	let userId = clientUrl.searchParams.get('ulid');
	
	if (!userId) {
		userId = Date.now();
	
		const urlParams = new URLSearchParams(window.location.search);
		urlParams.set('ulid', userId);
		const newUrl = window.location.pathname + '?' + decodeURI(urlParams.toString()) + window.location.hash;
		window.history.replaceState({ path: newUrl }, '', newUrl);
	}
	
	window.triggerUserlane = (market, page) => {
		Userlane('identify', userId, { market, page });
		Userlane('init', 'yv4zryk8g8');
	};
	`;
}

export { userlane };
